module.exports = __webpack_public_path__ + "img/OLED.26364c79.png";